import AdminRouter from "./AdminRouter";
import ProfileRouter from "./ProfileRouter";
import TutorRouter from "./TutorRouter";

let routes = [];
export default routes.concat(AdminRouter, ProfileRouter, TutorRouter);
